import {
	Component,
	EventEmitter,
	Input,
	Output,
	AfterViewInit,
} from '@angular/core';
import { NgForm } from '@angular/forms';
import { Address } from '@models/address';
import { Company, CompanyFields } from '@models/company';
import { LawFirm } from '@models/lawFirms';
import { Brokerage } from '@models/matter';
import { createId } from '@core/util/file';
import { Subject } from 'rxjs';

@Component({
	selector: 'app-company-add',
	templateUrl: './company-add.component.html',
	standalone: false,
})
export class CompanyAddComponent implements AfterViewInit {
	public _id;
	public _name = '';
	public _phoneNumber = '';
	public _fax = '';
	public _email = '';
	public _website = '';
	public _address: Address = null;
	public addressChanged: boolean = false;
	private _googlePlaceId = '';
	public initialValue;
	public forceSearchSubject: Subject<string> = new Subject<string>();
	public showCompanyInfo = false;
	public loading = false;
	public disableCountrySelect: boolean = false;

	@Input() set firm(value: Brokerage | LawFirm) {
		this.disableCountrySelect = true;
		this._id = value?.id ?? null;
		this._fax = value?.faxNumber ?? null;
		this._email = value?.email ?? null;
		this._phoneNumber = value?.phoneNumber ?? null;
		this._address = value?.address ?? null;
		//not to show the address search bar
		this.showCompanyInfo = true;
	}

	@Input() label = '';
	@Output() onSubmit = new EventEmitter<Company>();
	@Input() set name(value: string) {
		this._name = value;
		this.initialValue = value;
	}

	labels = CompanyFields;

	ngAfterViewInit(): void {
		this.loading = false;
		this.addressChanged = false;
		this.forceSearchSubject.next(this.initialValue);
	}

	_onSubmit(form: NgForm): void {
		if (form.valid) {
			this.loading = true;
			const company: Company = {
				id: this._id ? this._id : createId(),
				googlePlaceId: this._googlePlaceId,
				name: this._name,
				phoneNumber: this._phoneNumber,
				faxNumber: this._fax,
				email: this._email,
				address: this._address ?? null,
				website: this._website,
			};
			this.onSubmit.emit(company);
		}
	}

	onAddressUpdate($event) {
		this._address = $event;

		this.addressChanged = true;
	}

	setCompany(event: Address) {
		this._name = event?.name ?? '';
		this._website = event?.website ?? '';
		this._phoneNumber = event?.phoneNumber ?? '';
		this._address = event ?? null;
		this._googlePlaceId = event?.googlePlaceId ?? '';
		this.showCompanyInfo = true;
		this.addressChanged = true;
	}
}
